package fr.frux.core.database

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Tree(
  public val id: Long,
  public val species_id: Long,
  public val species_common_name_fr: String,
  public val species_scientific_name: String,
  public val species_form: String,
  public val harvest_part: String?,
  public val latitude: Double,
  public val longitude: Double,
  public val status: String,
  public val certainty: String,
  public val disputed: Long,
  public val description: String?,
  public val photo_url: String?,
  public val last_observed_at: Long?,
  public val created_by: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val cached_at: Long,
  public val site_id: Long?,
)
